import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class AGBeschaftigung extends AdornisEntity {
  static override _class = 'AGBeschaftigung';

  static override resolveID(entity: any): string {
    entity._id = entity._id ?? A.getGloballyUniqueID();
    return entity._id;
  }

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() }) _id!: string;

  @Field(() => Date)
  beschaftigungsbeginn: Maybe<Date>;

  @Field(() => String)
  arbeitgeberMitAdresse: Maybe<string>;

  @Field(() => String)
  entlohnungsArt: Maybe<'geringfügig entlohnt' | 'mehr als geringfügig entlohnt'>;

  @Field(() => Boolean, { default: v => v ?? false })
  mitEigenanteilZurRv: Maybe<boolean>;

  @Field(() => Int)
  lohn: Maybe<number>;
}
